{
	"color": ["#FFDB66", "#009aa4", "#38f990", "#E42600", "#7BF7FF", "#E8E8E8"],
	"backgroundColor": "transparent",
	"textStyle": {},
	"title": {
		"textStyle": {
			"color": "#ffffff"
		},
		"subtextStyle": {
			"color": "#aaaaaa"
		}
	},
	"line": {
		"itemStyle": {
			"borderWidth": 1
		},
		"lineStyle": {
			"width": "2"
		},
		"symbolSize": "0",
		"symbol": "emptyCircle",
		"smooth": false
	},
	"radar": {
		"itemStyle": {
			"borderWidth": 0
		},
		"lineStyle": {
			"width": "2"
		},
		"symbolSize": "0",
		"symbol": "emptyCircle",
		"smooth": false
	},
	"bar": {
		"itemStyle": {
			"barBorderWidth": "0",
			"barBorderColor": "#ffffff"
		}
	},
	"pie": {
		"itemStyle": {
			"borderWidth": "2",
			"borderColor": "#070F26"
		}
	},
	"scatter": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#E8E8E8"
		}
	},
	"boxplot": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#ffffff"
		}
	},
	"parallel": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#ffffff"
		}
	},
	"sankey": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#ffffff"
		}
	},
	"funnel": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#ffffff"
		}
	},
	"gauge": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#ffffff"
		}
	},
	"candlestick": {
		"itemStyle": {
			"color": "#e01f54",
			"color0": "#001852",
			"borderColor": "#f5e8c8",
			"borderColor0": "#b8d2c7",
			"borderWidth": 1
		}
	},
	"graph": {
		"itemStyle": {
			"borderWidth": "0",
			"borderColor": "#ffffff"
		},
		"lineStyle": {
			"width": 1,
			"color": "#aaa"
		},
		"symbolSize": "0",
		"symbol": "emptyCircle",
		"smooth": false,
		"color": ["#059681", "#00dbfc", "#fcca00", "#fc2200", "#ffffff"],
		"label": {
			"color": "#eeeeee"
		}
	},
	"map": {
		"itemStyle": {
			"areaColor": "#eeeeee",
			"borderColor": "#444444",
			"borderWidth": 0.5
		},
		"label": {
			"color": "#000000"
		},
		"emphasis": {
			"itemStyle": {
				"areaColor": "rgba(255,215,0,0.8)",
				"borderColor": "#444",
				"borderWidth": 1
			},
			"label": {
				"color": "rgb(100,0,0)"
			}
		}
	},
	"geo": {
		"itemStyle": {
			"areaColor": "#eeeeee",
			"borderColor": "#444444",
			"borderWidth": 0.5
		},
		"label": {
			"color": "#000000"
		},
		"emphasis": {
			"itemStyle": {
				"areaColor": "rgba(255,215,0,0.8)",
				"borderColor": "#444",
				"borderWidth": 1
			},
			"label": {
				"color": "rgb(100,0,0)"
			}
		}
	},
	"categoryAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#ffffff"
			}
		},
		"axisTick": {
			"show": true,
			"lineStyle": {
				"color": "#333333"
			}
		},
		"axisLabel": {
			"show": true,
			"color": "#ffffff"
		},
		"splitLine": {
			"show": false,
			"lineStyle": {
				"color": ["#ccc"]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"]
			}
		}
	},
	"valueAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#ffffff"
			}
		},
		"axisTick": {
			"show": true,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"color": "#ffffff"
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": ["#555555"]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
			}
		}
	},
	"logAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#ffffff"
			}
		},
		"axisTick": {
			"show": true,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"color": "#ffffff"
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": ["#555555"]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
			}
		}
	},
	"timeAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#ffffff"
			}
		},
		"axisTick": {
			"show": true,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"color": "#ffffff"
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": ["#ffffff"]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
			}
		}
	},
	"toolbox": {
		"iconStyle": {
			"borderColor": "#ffffff"
		},
		"emphasis": {
			"iconStyle": {
				"borderColor": "#ffffff"
			}
		}
	},
	"legend": {
		"textStyle": {
			"color": "#ffffff"
		}
	},
	"tooltip": {
		"axisPointer": {
			"lineStyle": {
				"color": "#ffffff",
				"width": 1
			},
			"crossStyle": {
				"color": "#ffffff",
				"width": 1
			}
		}
	},
	"timeline": {
		"lineStyle": {
			"color": "#293c55",
			"width": 1
		},
		"itemStyle": {
			"color": "#87f7cf",
			"borderWidth": 1
		},
		"controlStyle": {
			"color": "#293c55",
			"borderColor": "#293c55",
			"borderWidth": 0.5
		},
		"checkpointStyle": {
			"color": "#e43c59",
			"borderColor": "#c23531"
		},
		"label": {
			"color": "#293c55"
		},
		"emphasis": {
			"itemStyle": {
				"color": "#a9334c"
			},
			"controlStyle": {
				"color": "#293c55",
				"borderColor": "#293c55",
				"borderWidth": 0.5
			},
			"label": {
				"color": "#293c55"
			}
		}
	},
	"visualMap": {
		"color": ["#fc97af", "#87f7cf"]
	},
	"dataZoom": {
		"backgroundColor": "rgba(47,69,84,0)",
		"dataBackgroundColor": "rgba(47,69,84,0.3)",
		"fillerColor": "rgba(167,183,204,0.4)",
		"handleColor": "#a7b7cc",
		"handleSize": "100%",
		"textStyle": {
			"color": "#333333"
		}
	},
	"markPoint": {
		"label": {
			"color": "#eeeeee"
		},
		"emphasis": {
			"label": {
				"color": "#eeeeee"
			}
		}
	}
}
